const COLORS = {
  primary: '#4287f8',
  primaryDark: '#2659b0',
  secondary: '#7c9acf',

  white: '#fff',
  lightWhite: '#F5F5F5',
  lightGray: '#D8D8D8',
  gray: '#6b6b6b',
  darkGray: '#4d4d4d',
  black: '#000000',

  green: '#5bab3d',
  danger: '#fc5235',

  // NEW COLOR PALETTE
  greyscale: {
    white: '#ffffff',
    light: '#EBEBEB',
    medium: '#ADADAD',
    dark: '#5C5C5C',
    black: '#292F34',
    overlay: 'rgba(0, 0, 0, .2)',
  },
  brand: {
    primary: '#2B79BE',
    primaryDark: '#0F426F',
    secondary: '#8EBCE4',
    secondaryLight: '#96a3bd',
    secondaryDark: '#30344c',
  },
  uiSpecific: {
    alert: '#fd6767',
    facebookBlue: '#4267B2',
    transparent: 'rgba(0, 0, 0, 0)',
    success: '#169F41',
    danger: '#FB3D3D',
    warning: '#FFB300',
  },
}

export const transparency = (color = COLORS.greyscale.black, factor = 0) => {
  const transparencyValue = parseInt(factor * 255).toString(16)
  return `${color}${transparencyValue.length < 2 ? '0' : ''}${transparencyValue}`
}

export default COLORS
